import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPlay48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="play">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8599 39.4706L39.5562 25.8057C41.0763 25.0818 41.0763 22.9182 39.5562 22.1943L10.8599 8.5294C9.53271 7.8974 8.00005 8.86512 8.00005 10.3351L8.00005 37.6649C8.00005 39.1349 9.53271 40.1026 10.8599 39.4706ZM40.416 27.6114C43.4564 26.1637 43.4564 21.8363 40.416 20.3886L11.7198 6.72368C9.06536 5.45967 6.00005 7.39511 6.00005 10.3351L6.00005 37.6649C6.00005 40.6049 9.06537 42.5403 11.7198 41.2763L40.416 27.6114Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPlay24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="play">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.6379 9.29141C22.9182 10.3773 22.9182 13.6227 20.6379 14.7086L6.28983 21.541C4.29901 22.489 2.00002 21.0374 2.00002 18.8324L2.00002 5.16756C2.00002 2.96255 4.29901 1.51097 6.28983 2.45898L20.6379 9.29141ZM19.7781 12.9029C20.5382 12.5409 20.5382 11.4591 19.7781 11.0971L5.42996 4.2647C4.76635 3.9487 4.00002 4.43256 4.00002 5.16756L4.00002 18.8324C4.00002 19.5674 4.76635 20.0513 5.42996 19.7353L19.7781 12.9029Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconPlay16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="play">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.481 6.18764C16.02 6.90582 16.02 9.09418 14.481 9.81237L2.84573 15.2422C1.51977 15.861 -3.97268e-05 14.893 -3.96629e-05 13.4298L-3.91882e-05 2.5702C-3.91242e-05 1.10696 1.51977 0.139048 2.84573 0.75783L14.481 6.18764ZM1.99996 13.4298L13.6353 8L1.99996 2.5702L1.99996 13.4298Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
